import TableSkeleton from 'components/base/Skeletons';

const mapColsToSkeletons = cols => cols.map(col => 'singleline');

const LoadingTable = ({ cols, rowsNumber = 5 }) => {
  return (
    <div data-cy='loading-table'>
      <TableSkeleton
        columns={cols}
        skeletonColumns={mapColsToSkeletons(cols)}
        rowsNumber={rowsNumber}
      />
    </div>
  );
};

export default LoadingTable;
